export type WinnerItem = { award: string; winner: string };
export type WinnerCategory = {
  key: string;
  className: string;
  titleEn: string;
  titleZh: string;
  en: WinnerItem[];
  zh: WinnerItem[];
};

export const winnerCategories: WinnerCategory[] = [
  {
    key: 'arts',
    className: 'Winners_ArtsandCulture',
    titleEn: 'Arts and Culture',
    titleZh: '藝術與文化',
    en: [{ award: 'Outstanding VR & AR Interactive Travel Experience', winner: 'VIRTRIX & Ma On Shan Promotion of Livelihood & Recreation Association' }],
    zh: [{ award: '傑出虛擬實境與擴增實境互動旅遊體驗', winner: 'VIRTRIX及馬鞍山民康促進會' }],
  },
  {
    key: 'edtech',
    className: 'Winners_EdTech',
    titleEn: 'Educational Technology (EdTech)',
    titleZh: '教育科技',
    en: [
      { award: 'Outstanding AI Fitness Video Analytics System', winner: 'Archon Wellness Ltd' },
      { award: 'Outstanding GBA NexGen Talents Incubation Platform', winner: 'Bamboo Hong Kong Limited' },
      { award: 'Outstanding Integrated PLC Training Platform', winner: 'Electrical and Mechanical Services Department' },
      { award: 'Outstanding Adaptive Learning Solution', winner: 'One Ed Limited' },
      { award: 'Outstanding DeepTech Education Solutions', winner: 'Printact Limited' },
    ],
    zh: [
      { award: '傑出人工智能運動影像分析系統', winner: 'Archon Wellness Ltd' },
      { award: '傑出大灣區新世代人才孵化平台', winner: '竹賢香港有限公司' },
      { award: '傑出全方位 PLC 培訓平台', winner: '機電工程署' },
      { award: '傑出人工智能教育科技方案', winner: 'One Ed Limited' },
      { award: '傑出深科技教育方案', winner: 'Printact Limited' },
    ],
  },
  {
    key: 'geron',
    className: 'Winners_GeronTech',
    titleEn: 'Geron Technology (GeronTech)',
    titleZh: '樂齡科技',
    en: [
      { award: 'Outstanding Hearing Impairment and Brain Health Solution', winner: 'Dai3mimi Health-Tech Limited' },
      { award: 'Outstanding Chronic Pain Relief Products', winner: 'LinkAIQ Ltd' },
    ],
    zh: [
      { award: '傑出應對聽障和腦健康方案', winner: '複耳科技有限公司' },
      { award: '傑出慢性痛症舒緩產品', winner: 'LinkAIQ Ltd' },
    ],
  },
  {
    key: 'health',
    className: 'Winners_HealthTech',
    titleEn: 'Health Technology (HealthTech)',
    titleZh: '健康科技',
    en: [
      { award: 'Outstanding Insurance Digital Services Platform', winner: 'China Life Insurance (Overseas) Company Limited' },
      { award: 'Outstanding Chinese Medicinal Oil Packaging System', winner: 'Hong Kong Productivity Council' },
      { award: 'Outstanding Chinese Medicine Telemedicine Platform', winner: 'In Good Health Co. Ltd' },
      { award: 'Outstanding Innovative Chinese Medicine Picking and Delivery System', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding One-stop Virus Decision Support Platform', winner: 'Logistics and Supply Chain MultiTech R&D Centre & The Hong Kong Polytechnic University' },
      { award: 'Outstanding Medicament Consultation App', winner: 'Pharmalution Group Holdings Limited' },
      { award: 'Outstanding Healthcare Service App', winner: 'Ping An Healthcare and Technology Company Limited' },
    ],
    zh: [
      { award: '傑出保險數碼服務平台', winner: '中國人壽保險(海外)股份有限公司' },
      { award: '傑出中藥藥油包裝系統', winner: '香港生產力促進局' },
      { award: '傑出遙距中醫醫療平台', winner: 'In Good Health Co. Ltd' },
      { award: '傑出創新中藥配送系統', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出一站式病毒控制決策支援平台', winner: '物流及供應鏈多元技術研發中心及香港理工大學' },
      { award: '傑出藥物諮詢應用程式', winner: 'Pharmalution Group Holdings Limited' },
      { award: '傑出健康服務應用程式', winner: '平安健康醫療科技有限公司' },
    ],
  },
  {
    key: 'marTech',
    className: 'Winners_MarTech',
    titleEn: 'Marketing Technology (MarTech) (Smart Retail / e-Commerce)',
    titleZh: '行銷科技（智慧零售 / 電子商務）',
    en: [
      { award: 'Outstanding One-stop Global Online Shopping and Shipping Platform', winner: 'Buyandship' },
      { award: 'Outstanding Visitors Analytics Retail Application Solution', winner: 'Dayta AI' },
      { award: 'Outstanding Omnichannel eCommerce Operation Program', winner: 'EasyTok Technology Limited' },
      { award: 'Outstanding Mobile App Marketing Solution', winner: 'GoGoChart Technology Limited' },
      { award: 'Outstanding All-in-one Online Decoration Platform', winner: 'HK DECOMAN Technology Limited' },
      { award: 'Outstanding All Rounded Customers Relationship Management System', winner: 'Smart Business Consultancy Limited' },
    ],
    zh: [
      { award: '傑出一站式國際網購轉運平台', winner: 'Buyandship' },
      { award: '傑出訪客分析零售應用方案', winner: 'Dayta AI' },
      { award: '傑出全管道電商營運程式', winner: '易拓客科技有限公司' },
      { award: '傑出應用程式營銷方案', winner: 'GoGoChart Technology Limited' },
      { award: '傑出一站式網上裝修平台', winner: '裝修佬科技有限公司' },
      { award: '傑出全方位客戶關係管理系統', winner: '恩效有限公司' },
    ],
  },
  {
    key: 'metaverse',
    className: 'Winners_Metaverse',
    titleEn: 'Metaverse',
    titleZh: '元宇宙',
    en: [
      { award: 'Outstanding Production Line Optimisation Solution', winner: 'Hong Kong Productivity Council' },
      { award: 'Outstanding Virtual Teaching Production Platform', winner: 'Innowises Technology (Hong Kong) Limited' },
      { award: 'Outstanding Metaverse Art Exhibition Platform', winner: 'Metaart Shop Limited' },
      { award: 'Outstanding Web3 Smart Living Platform', winner: 'NFT Investment and Venture Limited' },
    ],
    zh: [
      { award: '傑出生產線優化方案', winner: '香港生產力促進局' },
      { award: '傑出虛擬教育系統平台', winner: '優先智創科技（香港）有限公司' },
      { award: '傑出元宇宙藝術展覽平台', winner: 'Metaart Shop Limited' },
      { award: '傑出 Web3 智慧生活平台', winner: 'NFT Investment and Venture Limited' },
    ],
  },
  {
    key: 'proTech',
    className: 'Winners_PropTech',
    titleEn: 'Property Technology (PropTech)',
    titleZh: '房地產科技',
    en: [
      { award: 'Outstanding Innovative Residential Enhancement Platform', winner: 'Butler' },
      { award: 'Outstanding Rodent Control Management Platform', winner: 'Electrical and Mechanical Services Department' },
      { award: 'Outstanding 5G Smart Construction Solutions', winner: 'HKT | 1O1O' },
      { award: 'Outstanding Smart Property Operation Management', winner: 'Nan Fung Property Management - TKO Plaza' },
    ],
    zh: [
      { award: '傑出創新科技全方位住戶體驗平台', winner: 'Butler' },
      { award: '傑出鼠患管理平台', winner: '機電工程署' },
      { award: '傑出 5G 智慧建築方案', winner: 'HKT | 1O1O' },
      { award: '傑出智慧物業營運管理', winner: '南豐物業管理－將軍澳廣場 (商場)' },
    ],
  },
  {
    key: 'business',
    className: 'Winners_SmallBusiness',
    titleEn: 'Small and Medium Business (Tourism / Human Resources / Administration)',
    titleZh: '中小型企業（旅遊 / 人力資源 / 行政）',
    en: [
      { award: 'Outstanding One-stop Digital Transformation Solutions Platform', winner: 'Hong Kong Productivity Council' },
      { award: 'Outstanding Cross-platform Virtual Game Experience Solution', winner: 'Master Edutainment Limited' },
    ],
    zh: [
      { award: '傑出一站式數碼轉型方案平台', winner: '香港生產力促進局' },
      { award: '傑出跨平台虛擬遊戲體驗方案', winner: 'Master Edutainment Limited' },
    ],
  },
  {
    key: 'enviro',
    className: 'Winners_SmartBuilding',
    titleEn: 'Smart Building / Environment (EnviroTech) / Green Technology',
    titleZh: '智能建設 / 環境科技 / 綠色科技',
    en: [
      { award: 'Outstanding Smart Cleaning and Disinfection Solution', winner: 'Avalon SteriTech' },
      { award: 'Outstanding Smart Flooding Monitoring System', winner: 'Electrical and Mechanical Services Department & Drainage Services Department' },
      { award: 'Outstanding All-in-one Energy Saving System', winner: 'Energys Spectrum Limited' },
      { award: 'Outstanding Innovative Food Waste Liquefaction System', winner: 'Hong Kong Productivity Council & AEL (International Holdings) Limited' },
      { award: 'Outstanding Remote E-inspection System for Cross Border MiC Logistics', winner: 'Logistics and Supply Chain MultiTech R&D Centre & iLab, HKU' },
      { award: 'Outstanding Construction Resources and Progress Management System', winner: 'Logistics and Supply Chain MultiTech R&D Centre & The Hong Kong Polytechnic University' },
      { award: 'Outstanding Smart and Green Living Membership App', winner: 'Nan Fung Group' },
      { award: 'Outstanding Air Purification Technology Solution', winner: 'RHT Industries Limited' },
    ],
    zh: [
      { award: '傑出智能清潔與消毒方案', winner: '鎧耀環境衛生科技' },
      { award: '傑出智慧防洪監察系統', winner: '機電工程署及渠務署' },
      { award: '傑出一站式節能系統', winner: 'Energys Spectrum Limited' },
      { award: '傑出創新廚餘液化系統', winner: '香港生產力促進局及聯誼工程（國際控股）有限公司' },
      { award: '傑出跨境 MiC 物流遠程電子檢測系統', winner: '物流及供應鏈多元技術研發中心及香港大學建築學院智能城市建造實驗室' },
      { award: '傑出建築工程資源與進度管理系統', winner: '物流及供應鏈多元技術研發中心及香港理工大學' },
      { award: '傑出智能及綠色生活應用程式', winner: '南豐集團' },
      { award: '傑出空氣淨化技術方案', winner: '信山實業有限公司' },
    ],
  },
  {
    key: 'gov',
    className: 'Winners_SmartGovernment',
    titleEn: 'Smart Government',
    titleZh: '智慧政府',
    en: [
      { award: 'Outstanding Building Information Modelling Asset Management System', winner: 'Electrical and Mechanical Services Department' },
      { award: 'Outstanding AI Hill Fire Detection System', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Isolation Facility Service System', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Landslip Prevention Electronic Form System', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Real-time E-Lock Tracking System for Vaccine Delivery', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
    ],
    zh: [
      { award: '傑出建築信息模擬及資產管理系統', winner: '機電工程署' },
      { award: '傑出人工智能山火檢測系統', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出隔離設施服務系統', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出防止山泥傾瀉電子表格系統', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出實時追蹤疫苗運送電子鎖系統', winner: '物流及供應鏈多元技術研發中心' },
    ],
  },
  {
    key: 'mobility',
    className: 'Winners_SmartMobility',
    titleEn: 'Smart Mobility',
    titleZh: '智慧出行',
    en: [
      { award: 'Outstanding All-in-one Smart Boarding Application System', winner: 'Airport Authority Hong Kong & Immigration Department of the Hong Kong Special Administrative Region' },
      { award: 'Outstanding AI Transportation Planning Integration Solution', winner: 'Alpha AI Technology Limited' },
      { award: 'Outstanding Telemedicine and Personal Healthcare Management App', winner: 'Alpine Intelligent Medical Corporation Limited' },
      { award: 'Outstanding Road Pavement Safety Monitoring Device', winner: 'Hong Kong Productivity Council' },
      { award: 'Outstanding Antenna Detection Payment Solution', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Vehicles Detection and Alert System', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Vehicles Road Tolling RFID Tag', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Seat Occupancy and Seat Belt Fastening Detection System for Bus and Minibus', winner: 'Logistics and Supply Chain MultiTech R&D Centre & CLP Power Hong Kong Limited' },
      { award: 'Outstanding GNSS Positioning Service and Integration Technology Solution', winner: 'Logistics and Supply Chain MultiTech R&D Centre & The Hong Kong Polytechnic University' },
      { award: 'Outstanding Innovative Multi-function Edge AI Platform for Computer Vision Applications', winner: 'Logistics and Supply Chain MultiTech R&D Centre & The Hong Kong University of Science and Technology & Smart Sensing Ltd' },
      { award: 'Outstanding All Man Kind Inclusive Bus App', winner: 'The Kowloon Motor Bus Company (1933) Limited' },
      { award: 'Outstanding Flexible Insurtech App', winner: 'YAS Digital Limited' },
      { award: 'Outstanding Enterprise Resource Planning Solution', winner: 'ZhenHub Technologies Ltd.' },
    ],
    zh: [
      { award: '傑出一站式智能登機應用系統', winner: '香港機場管理局及香港特別行政區入境事務處' },
      { award: '傑出交通規劃整合方案', winner: 'Alpha AI Technology Limited' },
      { award: '傑出遙距醫療及個人健康管理應用程式', winner: '訊智醫療有限公司' },
      { award: '傑出路面安全監測裝置', winner: '香港生產力促進局' },
      { award: '傑出天線偵測收費解決方案', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出車輛檢測及警報系統', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出車輛道路收費射頻標籤', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出巴士和小巴座位及安全帶佩戴狀況偵測系統', winner: '物流及供應鏈多元技術研發中心及中華電力有限公司' },
      { award: '傑出 GNSS 定位整合及服務技術方案', winner: '物流及供應鏈多元技術研發中心及香港理工大學' },
      { award: '傑出計算機視覺應用多功能邊緣 AI 創新平台', winner: '物流及供應鏈多元技術研發中心及香港科技大學及Smart Sensing Ltd' },
      { award: '傑出全人共融巴士應用程式', winner: '九龍巴士（一九三三）有限公司' },
      { award: '傑出靈活保險科技應用程式', winner: 'YAS 微保險' },
      { award: '傑出企業資源規劃方案', winner: 'ZhenHub Technologies Ltd.' },
    ],
  },
  {
    key: 'management',
    className: 'Winners_SmartWorkforce',
    titleEn: 'Smart Workforce Management',
    titleZh: '智慧勞動管理',
    en: [
      { award: 'Outstanding Digital Smart Workforce Solution', winner: 'FUJIFILM Business Innovation Hong Kong' },
      { award: 'Outstanding VR-based Crime Scenes Training System', winner: 'Logistics and Supply Chain MultiTech R&D Centre & VOTANIC Limited' },
    ],
    zh: [
      { award: '傑出數碼智慧勞動解決方案', winner: '富士膠片商業創新香港' },
      { award: '傑出虛擬犯罪現場訓練系統', winner: '物流及供應鏈多元技術研發中心及華拓域科技有限公司' },
    ],
  },
  {
    key: 'wearable',
    className: 'Winners_Wearable',
    titleEn: 'Wearable / Internet of Things (IOT) / Robotics',
    titleZh: '智慧衣服 / 物聯網 / 機械人技術',
    en: [
      { award: 'Outstanding Hiking Safety System', winner: 'Electrical and Mechanical Services Department' },
      { award: 'Outstanding Fire Alarm Mobile Administration System', winner: 'FireAlert Limited' },
      { award: 'Outstanding Smart Pier Monitoring System', winner: 'Hong Kong Productivity Council' },
      { award: 'Outstanding Concrete Cubes Automated Testing System', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Multi-purpose Mobile Robot', winner: 'Logistics and Supply Chain MultiTech R&D Centre' },
      { award: 'Outstanding Indoor and Outdoor Entourage Robot', winner: 'Logistics and Supply Chain MultiTech R&D Centre & Aberdeen Kai-fong Welfare Association Limited' },
      { award: 'Outstanding Robo Service and Security Technology System', winner: 'Molekiu Limited' },
    ],
    zh: [
      { award: '傑出遠足安全系統', winner: '機電工程署' },
      { award: '傑出火災警報流動管理系統', winner: '火訊科技有限公司' },
      { award: '傑出智慧碼頭監控系統', winner: '香港生產力促進局' },
      { award: '傑出混凝土磚自動化測試系統', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出多用途自主移動機械人', winner: '物流及供應鏈多元技術研發中心' },
      { award: '傑出室內外隨行機械人', winner: '物流及供應鏈多元技術研發中心及香港仔坊會' },
      { award: '傑出機械人服務與安全技術系統', winner: '默歷奇有限公司' },
    ],
  },
];
